import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import FiPlus from "../../../assets/icons/plus";
import RxCross2 from "../../../assets/icons/cross";
import FaCheck from "../../../assets/icons/check";
import RiShapesFill from "../../../assets/icons/shapes";
import RiShapesLine from "../../../assets/icons/shapesOutline";
import { isArray } from "../../../utils/helpers";

export default function FeelingsFilter({ className = "" }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get("category");
  const { categories = [] } = useSelector((state) => state.common || {});

  return (
    <Dropdown className={className}>
      <Dropdown.Toggle
        variant="transparent"
        id="dropdown-basic"
        className="border-0 hstack gap-1 px-0">
        {category ? (
          <span className="bg-primary-light hstack align-items-center gap-1 border border-primary rounded-pill px-3 py-2 text-color">
            {categories?.find((cat) => cat._id === category)?.name}
            <RxCross2 className="width-20 height-20" />
          </span>
        ) : (
          <span className="hstack align-items-center gap-1 border border-primary rounded-pill px-3 py-2 text-primary">
            <FiPlus className="width-20 height-20" />
            Feeling
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="width-175">
        {[{ name: "All", _id: "" }, ...isArray(categories)].map((option) => (
          <Dropdown.Item
            key={option._id}
            as={"p"}
            className="pointer m-0 py-2"
            onClick={(e) => {
              e.preventDefault();
              setSearchParams(
                (prev) => {
                  prev.set("category", option._id);
                  return prev;
                },
                { replace: true }
              );
            }}>
            <div
              className={`hstack align-items-center gap-2 ${
                option._id === category ? "fw-bold text-primary" : ""
              }`}>
              {option._id ? (
                <span
                  className="optionIcon"
                  dangerouslySetInnerHTML={{
                    __html: option._id === category ? option.iconFilled : option.iconRegular,
                  }}
                />
              ) : category ? (
                <RiShapesLine className="width-20 height-20" />
              ) : (
                <RiShapesFill className="width-20 height-20" />
              )}

              <span className="">{option.name}</span>
              {option._id === category && <FaCheck />}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
